import * as _ from 'lodash';
import * as PIXI from 'pixi.js';

import Utils from '@/assets/js/Utils';

import ObjectData from '@/assets/data/object';

export default class TextureManager {
  static get(id) {
    return PIXI.Texture.from(id);
  }

  static load(onLoaded) {
    const loader = new PIXI.Loader();
    const add = (key, texture) => {
      if (TextureManager._isExist(key)) return;
      loader.add(key, texture);
    };

    _.forEach(ObjectData, (info, index) => {
      const image = info.image;
      if (Array.isArray(image)) {
        for (let i = 0; i < image.length; i++) {
          const item = image[i];
          add(`${info.id}_${i}`, TextureManager._getImage(item, 'object'));
        }
      } else {
        add(`${info.id}`, TextureManager._getImage(image, 'object'));
      }
    });

    const setPlayerAnimation = (key, length) => {
      const array = [];
      for (let i = 1; i <= length; i++) {
        const number = Utils.getZeroPadding(i, 3);
        array.push(`player_${key}_${number}.png`);
      }
      _.forEach(array, (image, index) => {
        add(
          `player_${key}_${index + 1}`,
          TextureManager._getImage(image, 'player')
        );
      });
    };

    setPlayerAnimation('run', 4);
    setPlayerAnimation('jump', 6);
    setPlayerAnimation('turn', 7);
    setPlayerAnimation('damage', 4);

    add(
      'star_white',
      TextureManager._getImage('item_happy_turn_star_white.png', 'object')
    );
    add(
      'star_yellow',
      TextureManager._getImage('item_happy_turn_star_yellow.png', 'object')
    );

    add('bg_sky', TextureManager._getImage('bg_sky.png', 'background'));
    loader.load(() => onLoaded());
  }

  static _getImage(imageName, key) {
    return require(`@/assets/images/game/${key}/${imageName}`);
  }

  static _isExist(id) {
    return _.has(PIXI.utils.TextureCache, id);
  }
}
